import React, {Component} from "react";
import {configHeaderVariant, configIndentReportByCabang,} from "./config";
import * as R from "ramda";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class IndentReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableConfig: [
                {name: "kodeVariant", label: "Kode Varian"},
                {name: "variantName", label: "Nama Varian"},
                {name: "kodeWarna", label: "Kode Warna"},
                {name: "colorName", label: "Nama Warna"},
                {name: "indentAmount", label: "Jumlah Inden", options: {sort: false}},
                {name: "composition", label: "% komposisi", options: {sort: false, customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
            ],
            dataTable: [],
        };
    };

    componentDidMount() { 
        this.fetchData()
     }

    componentDidUpdate(prevProps) {
        if (prevProps.doSearch !== this.props.doSearch && this.props.doSearch) {
            this.fetchData();
        }
    };

    fetchData = async () => {
        const {handleTriggerLoading, isAllSelected, dataCabang, search, onSuccessSearch} = this.props;
        let dataKodeCabang = search;

        handleTriggerLoading()
        if(isAllSelected){
            dataKodeCabang = dataCabang.map((item) => item.kodeCabang);
        }

        const res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanInden,
          setError: this.props.setError,
          menuName:
            "Dashboard Level Kepala Cabang Keatas - Laporan Inden",
          args: {
            kodeCabang: dataKodeCabang,
            employeeIdTeamLeader: this.props.idLeader,
          },
        });
        handleTriggerLoading()
        onSuccessSearch()

        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            this.setState({
                dataTable: res.data.data
            })
        }
    };

    render() {
        return (
            <>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    options={{pagination: false, serverSide: false}}
                />
            </>
        );
    };
}

export default IndentReport;